import { useQuery } from "@apollo/client";
import { PROFILE_QUESTIONS_QUERY } from "@/api/queries/profileQuestions";
import {
  ProfileQuestionsQuery,
  ProfileQuestionsQueryVariables,
} from "@/__generated__/types";

export interface UseProfileQuestionsParams {
  notAnsweredByUserId?: string;
  skip?: boolean;
}

export const useProfileQuestions = ({
  notAnsweredByUserId,
  skip = false,
}: UseProfileQuestionsParams = {}) => {
  const { data, loading, error, refetch } = useQuery<
    ProfileQuestionsQuery,
    ProfileQuestionsQueryVariables
  >(PROFILE_QUESTIONS_QUERY, {
    variables: {
      notAnsweredByUserId,
    },
    skip,
  });

  return {
    questions: data?.profileQuestions?.nodes || [],
    loading,
    error,
    refetch,
  };
};
